import { ENDPOINT_GENERATE_EXPLANATION_FOR_RECORDING } from "@constants/urls";
import { isWeb } from "@helpers/platform";
import { captureErrorToSentry } from "@helpers/sentry-logger";
import { useAppStore } from "@hooks/useAppStore";
import { supabase } from "libs/supabase";

const uploadRecording = async (blob: Blob, fileName: string) => {
	const appName = useAppStore.getState().app.name;
	const commonUrl =
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public";
	const finalFileName = `${appName}/${fileName}`;
	const uploadData = isWeb ? blob : new FormData();

	if (!isWeb) {
		(uploadData as FormData).append("file", {
			uri: blob,
			type: "audio/m4a",
			name: fileName,
		} as never);
	}

	const { data, error } = await supabase.storage
		.from("recordings")
		.upload(finalFileName, uploadData);

	if (error) {
		return null;
	}

	return `${commonUrl}/${data.fullPath}`;
};

export const qTranscript = "Where are you from?";
export const rTranscript = "I am from the United States.";
export const g = {
	high: "Includes city and country",
	medium: "Includes country",
	low: "Does not include country",
};
export const generateRatingPrompt = (
	questionTranscript: string,
	responseTranscript: string,
	grades: { high: string; medium: string; low: string },
) => {
	const { high, medium, low } = grades;
	const result = `Was the response relevant and appropriate to the question? Respond with a rating of "High," "Medium," or "Low."
  Question: ${questionTranscript}
  Response: ${responseTranscript}
  ###
  How to grade responses (only use if the values are defined):
  "High": ${high}
  "Medium": ${medium}
  "Low": ${low}
  ###
  Rating:`;
	return result;
};

export const generateExplanationPrompt = (
	questionTranscript: string,
	responseTranscript: string,
	grades: { high: string; medium: string; low: string },
	rating?: string,
) => {
	const { high, medium, low } = grades;
	const result = `Question: ${questionTranscript}
  Response: ${responseTranscript}
  ###
  How to grade responses (only use if the values are defined):
  "High": ${high}
  "Medium": ${medium}
  "Low": ${low}
  ###
  Relevancy:  ${rating}
  ###
  Generate an explanation according to the following format:
  ###
  Your response, **${responseTranscript}** is {highly (if "High"), somewhat (if "Medium"), not (if "Low")} relevant because {detailed explanation}.
  An appropriate response to the question would include {components of an appropriate and highly relevant response}. For example, {provide an example}.
  ###
  Explanation:`;
	return result;
};
const generateText = async (text: string) => {
	try {
		const result = await fetch(ENDPOINT_GENERATE_EXPLANATION_FOR_RECORDING, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ text }),
		});
		const json = await result.json();
		return json;
	} catch (_error) {
		const error = new Error("Error generating text");
		captureErrorToSentry(error, {
			error: JSON.stringify(_error),
		});
	}
};

export { generateText, uploadRecording };
